import * as Sentry from '@sentry/browser'
import { getContextOnPageLoad } from './getContextOnPageLoad'
import { reportMetricsOnPageLoad } from './reportMetricsOnPageLoad'
import { reportServiceWorkerMetrics } from './reportServiceWorkerMetrics'

const startReportingMetricsFromServiceWorker = (isEnabled: boolean) => {
  if (!('serviceWorker' in navigator) || !isEnabled) return

  let callIndex = 0
  const handler = async () => {
    await reportServiceWorkerMetrics(callIndex++)
  }

  setInterval(handler, 10_000)
}

let wasReported = false
export const reportMetrics = async (isSwEnabled: boolean) => {
  if (wasReported) return
  wasReported = true

  try {
    const context = await getContextOnPageLoad()
    await reportMetricsOnPageLoad({ context, isSwEnabled })
    startReportingMetricsFromServiceWorker(isSwEnabled)
  } catch (err) {
    Sentry.captureException(err)
  }
}
